import React from "react";
import {useMutation} from "react-query";
import Alert from "react-s-alert";

import {readResidentNameAnswer} from "../../../models/AdmissionModel.helpers";
import {CANCELLATION_REASONS} from "../../delete-admission-modal/consts";
import {AdmissionsService} from "../../../services/AdmissionsService";
import {DeleteAdmissionModal} from "../../delete-admission-modal";
import {useAdmissionsDeleteModalContext} from "./context";
import {getWorkflowLabel} from "../../start-workflow/workflowMapping";

type StateProps = Readonly<{
  onDeleted?: (admissionId: string) => void;
}>;

export const AdmissionsDeleteAdmissionModal = ({onDeleted}: StateProps) => {
  const {admission, toggle} = useAdmissionsDeleteModalContext();

  const {mutate, isLoading} = useMutation(
    ({admissionId, reason}: {admissionId: string; reason: string}) =>
      AdmissionsService.delete(admissionId, reason),
    {
      onError: err => {
        Alert.error(
          `Failed to delete the ${getWorkflowLabel(admission?.workflowType)}`,
        );
      },
      onSuccess: (_data, {admissionId}) => {
        Alert.success(
          `${getWorkflowLabel(
            admission?.workflowType,
          )} was successfully deleted.`,
        );
        onDeleted?.(admissionId);
      },
      onSettled: () => {
        toggle();
      },
    },
  );

  return (
    <DeleteAdmissionModal
      workflowType={admission?.workflowType}
      isOpen={!!admission}
      admissionCode={admission?.code}
      residentName={readResidentNameAnswer(admission)}
      isLoading={isLoading}
      cancellationReasons={CANCELLATION_REASONS}
      onCancel={data => mutate({admissionId: admission?.id, ...data})}
      onRequestClose={() => toggle()}
      admissionStatus={admission?.status}
    />
  );
};
